import React, { useEffect } from "react";
import { I2cInput } from "@webcomponents/i2cwebcomponents/dist/react";
import { useForm, Controller } from "react-hook-form";
import * as Yup from "yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { yupResolver } from "@hookform/resolvers/yup";

import "../../PrepaidComponents/Prepaid.scss";
const ProgramVelocity = ({
  setFormValidStates,
  setAddFormData,
  addFormData,
  formDataJson,
  isFetching,
}) => {
  const generalErrorMessge = "Field is required";
  const validationSchema = Yup.object({
    pf_pvl_caf: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_cal: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_max_num_payments: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_max_cred_line: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_min_trans_amount: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_max_trans_amount: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_min_int_trans_amount: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
    pf_pvl_max_int_trans_amount: Yup.string()
      .required(generalErrorMessge)
      .min(1, generalErrorMessge),
  });

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      pf_pvl_caf: "",
      pf_pvl_cal: "",
      pf_pvl_max_num_payments: "",
      pf_pvl_max_cred_line: "",
      pf_pvl_min_trans_amount: "",
      pf_pvl_max_trans_amount: "",
      pf_pvl_min_int_trans_amount: "",
      pf_pvl_max_int_trans_amount: "",
    },
  });

  const fields = [
    "pf_pvl_caf",
    "pf_pvl_cal",
    "pf_pvl_max_num_payments",
    "pf_pvl_max_cred_line",
    "pf_pvl_min_trans_amount",
    "pf_pvl_max_trans_amount",
    "pf_pvl_min_int_trans_amount",
    "pf_pvl_max_int_trans_amount",
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[5]["5_1"][field] ?? "");
      });
      methods.trigger();
    }
  }, [isFetching]);

  // Controlls destructuring from the method
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = methods;

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      5: {
        ...addFormData["5"],
        "5_1": { ...values },
      },
    });
  };
  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("5_1", true);
    else setFormValidStates("5_1", false);
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div i2c-grid="grid gap-column-sm gap-row-md">
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_caf"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  label="Cash Advance Frequency (Daily)"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_caf"}
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_caf && methods.formState.touchedFields.pf_pvl_caf
                  ? true
                  : false
              }
              message={errors.pf_pvl_caf?.message ?? "Invalid input"}
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_cal"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_cal"}
                  label="Cash Advance Limit Amount (Daily)"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_cal && methods.formState.touchedFields.pf_pvl_cal
                  ? true
                  : false
              }
              message={errors.pf_pvl_cal?.message ?? "Invalid input"}
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_max_num_payments"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_max_num_payments"}
                  label="Maximum Number of Payments (Daily)"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_max_num_payments &&
                methods.formState.touchedFields.pf_pvl_max_num_payments
                  ? true
                  : false
              }
              message={
                errors.pf_pvl_max_num_payments?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_max_cred_line"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  label="Maximum Credit Line"
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_max_cred_line"}
                ></I2cInput>
              )}
              label="Maximum Credit Line"
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_max_cred_line &&
                methods.formState.touchedFields.pf_pvl_max_cred_line
                  ? true
                  : false
              }
              message={errors.pf_pvl_max_cred_line?.message ?? "Invalid input"}
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_min_trans_amount"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_min_trans_amount"}
                  label="Minimum Transaction Amount"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_min_trans_amount &&
                methods.formState.touchedFields.pf_pvl_min_trans_amount
                  ? true
                  : false
              }
              message={
                errors.pf_pvl_min_trans_amount?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_max_trans_amount"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_max_trans_amount"}
                  label="Maximum Transaction Amount"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_max_trans_amount &&
                methods.formState.touchedFields.pf_pvl_max_trans_amount
                  ? true
                  : false
              }
              message={
                errors.pf_pvl_max_trans_amount?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_min_int_trans_amount"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_min_int_trans_amount"}
                  label="Minimum International Transaction Amount"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_min_int_trans_amount &&
                methods.formState.touchedFields.pf_pvl_min_int_trans_amount
                  ? true
                  : false
              }
              message={
                errors.pf_pvl_min_int_trans_amount?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
        <div i2c-grid="6@md">
          <div className="single-field-wrapper">
            <Controller
              name="pf_pvl_max_int_trans_amount"
              control={control}
              render={({ field }) => (
                <I2cInput
                  {...field}
                  className="single-input-field"
                  required
                  onI2cInput={(e) => {
                    const value = e.target.value;
                    field.onChange(value);
                    handleValueChanges();
                  }}
                  size="large"
                  name={"pf_pvl_max_int_trans_amount"}
                  label="Maximum International Transaction Amount"
                ></I2cInput>
              )}
            />
            {/* <ErrorMessage
              show={
                errors.pf_pvl_max_int_trans_amount &&
                methods.formState.touchedFields.pf_pvl_max_int_trans_amount
                  ? true
                  : false
              }
              message={
                errors.pf_pvl_max_int_trans_amount?.message ?? "Invalid input"
              }
            /> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ProgramVelocity;
